import './ServiceRequestObjectChange.css';

import {
  getServiceRequestDetailsAction,
  pushViewAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {replaceTranslations, serviceRequestPostCall} from '../../../utils/util';

import {
  Box,
  Button,
  CircularProgress,
  useToastProvider,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const ServiceRequestObjectChange = (props) => {
  const {t} = useTranslation();

  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const {enqueueToast} = useToastProvider();

  const objectChangeSubmitHandler = () => {
    setSubmitDisabled(true);
    setLoader(true);

    const reqBody = {};
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }

    serviceRequestPostCall(
      {
        requestType: 'Object Change',
        contractNumber: props.contractNumber,
        countryCode: props.country,
        userEmail: props.userDetails.email,
        ...reqBody,
      },
      enqueueToast,
      'OBJECT_CHANGE_SERVICE_REQUEST',
      () => {
        setLoader(false);
        setSubmitDisabled(false);
        appStore.dispatch(getServiceRequestDetailsAction(null));
        appStore.dispatch(pushViewAction('serviceRequestDashboard'));
      },
      replaceTranslations(
        t('SERVICE_REQUEST_LIMIT'),
        50,
        t('OBJECT_CHANGE_REQUEST')
      ),
      t('SERVICE_REQUEST_SUCCESS'),
      t('SERVICE_REQUEST_CREATION_FAILED'),
      () => {}
    );
  };

  const formButtonControls = () => {
    return (
      <div className="buttonControls">
        <Button
          id="cancelButton"
          onClick={() => props.cancelButtonClick(null)}
          variant="secondary"
        >
          {t('CANCEL')}
        </Button>

        <Button
          disabled={submitDisabled}
          id="objectChangePrimaryBtn"
          variant="primary"
          onClick={() => objectChangeSubmitHandler()}
          startIcon={
            loader && <CircularProgress size="small" style={{color: '#000'}} />
          }
        >
          {t('SUBMIT')}
        </Button>
      </div>
    );
  };

  return (
    <div className={'ServiceRequestObjectChangeWrapper'}>
      <Box pl={4} pr={4} pb={4}>
        {formButtonControls()}
      </Box>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contractDetails: state.appStates.contractDetails?.accountDetails,
    userDetails: state.appStates.userDetailsInfo,
  };
};

export default connect(mapStateToProps)(ServiceRequestObjectChange);
